import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { cn } from '@anytag/shared-utils';
import { Form } from '@anytag/shared-atoms';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { AccountListDomain } from '../types';
import { AccountFilterFormKeys } from './schemaTypes';
import { useAccountsFilterOptions } from './hooks';

export interface TemplateProps {
  onSubmit?: () => void;
  keywordPlaceholder?: string;
  domain: AccountListDomain;
}

export const Template = ({ onSubmit, keywordPlaceholder, domain }: TemplateProps) => {
  const { isAdminStaff } = useUserRoles();
  const { t } = useTranslation();
  const { allAvailableCountryOptions, analyticsPlanOptions, verifiedOptions, tikTokAdvertiserPlanOptions } =
    useAccountsFilterOptions();

  const isAdvertiserPage = domain === 'advertiser';
  const selectorClassName = cn(isAdvertiserPage ? 'max-w-40' : 'max-w-48.5');

  return (
    <Form.Fields>
      <TextSearchField<AccountFilterFormKeys> name="keyword" onSubmit={onSubmit} placeholder={keywordPlaceholder} />

      {isAdvertiserPage ? (
        <>
          <SelectorField<AccountFilterFormKeys>
            name="tiktokPlan"
            onSubmit={onSubmit}
            className={selectorClassName}
            options={tikTokAdvertiserPlanOptions}
            placeholder={t<string>('Selector.TikTok Special')}
          />

          <SelectorField<AccountFilterFormKeys>
            name="analyticsPlan"
            onSubmit={onSubmit}
            className={selectorClassName}
            options={analyticsPlanOptions}
            placeholder={t<string>('Selector.Analytics Plan')}
          />
        </>
      ) : null}

      <SelectorField<AccountFilterFormKeys>
        name="countryIds"
        onSubmit={onSubmit}
        className={selectorClassName}
        options={allAvailableCountryOptions}
        placeholder={t<string>('Selector.Countries')}
        multiple
      />

      {isAdminStaff ? (
        <SelectorField<AccountFilterFormKeys>
          onSubmit={onSubmit}
          name="verifiedStatus"
          className="max-w-48.5"
          options={verifiedOptions}
          placeholder={t<string>('Selector.Verification Status')}
        />
      ) : null}
    </Form.Fields>
  );
};
